module.exports = __webpack_public_path__ + "static/media/logo-carplat@2x.e75539ae.png";